import Vue from 'vue';
import VueI18n from 'vue-i18n';
import Mustache from 'mustache';
import emergency from './emergency';
import { getLanguageLong } from '@/utils/locale';

import { i18nInit, i18nGet } from '@didi/i18n-plugin';
i18nInit(require('./i18n-info'));

import zhCN from './zh-CN';
import enUS from './en-US';
// import ptBR from './pt-BR';
import esMX from './es-MX';
import es419 from './es-419';

Object.assign(zhCN, emergency['zh-CN']);
Object.assign(enUS, emergency['en-US']);
Object.assign(esMX, emergency['es-MX']);
Object.assign(es419, emergency['es-419']);

Vue.use(VueI18n);

const lang = getLanguageLong();

class CustomFormatter {
  interpolate(message, values) {
    // 觉得Mustache太重，可以实现一个简版
    return Mustache.render(message, values);
  }
}

export default new VueI18n({
  locale: lang, // 设置地区，根据项目自定设定
  formatter: new CustomFormatter(), // 适配I18N翻译平台占位符 {{variable}}
  messages: {
    'en-US': i18nGet(enUS, 'en-us'),
    'zh-CN': i18nGet(zhCN, 'zh-cn'),
    // 'pt-BR': i18nGet(ptBR, 'pt-br'),
    'es-MX': i18nGet(esMX, 'es-mx'),
    'es-419': i18nGet(es419, 'es-419'),
  },
});
